import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the record table transaction report view.
 */
export default class recordTableTransReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Datatable view
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enable row selection
            scrollY: screen.width < 820 ? false : true, // Conditional vertical scrolling
            columns: [
                // Column definitions
                {
                    id: 'Id',
                    header: _('Ticket Det Id'), // Localized header
                    width: 100,
                    sort: 'int', // Sorting type
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Column for Type
                {
                    id: 'TicketId',
                    header: _('Ticket ID'), // Localized header
                    width: 100,
                    sort: 'int',
                },
                { id: 'Date', header: _('Fecha'), width: 150, sort: 'int' }, // Column for Date
                {
                    id: 'TransactionId',
                    header: _('Transacción Id'), // Localized header
                    width: 150,
                    sort: 'int',
                },
                {
                    id: 'Amount',
                    header: _('Monto'), // Localized header
                    width: 100,
                    format: webix.i18n.priceFormat, // Price formatting
                    exportType: 'number', // Export type
                    sort: 'int',
                },
            ],
            loadahead: devConfig.getDefaultDataFetch(), // Data fetch configuration
            pager: 'pagerA', // Pager ID
            url: devConfig.geturlApi() + 'null/Report/GetBetHistoryTransactions', // API endpoint for data
        };
    }

    /**
     * Initializes the grid with event listeners and data loading.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        var url = grid.data.url; // URL for data loading
        var filter = ''; // Filter string for API requests
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            // Event listener for filtering
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // String to build query parameters
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter entries
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object filters
                    if (object[i][0] == 'Datepicker') {
                        // Handle date range filter
                        var date = object[i][1].split(' - '); // Split date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add start date
                        string1 = string1 + '&dateTo=' + date[1]; // Add end date
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object filter to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object filters
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateTo=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateFrom=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load new data with filters
            filter = string1; // Update filter string
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event listener for sorting
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir); // Load sorted data
        });
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.load(url + '?id=' + idUser); // Load data for specific user
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
